import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { brushes as e } from "./brushes.js";
import { WGLDrawPhase as r } from "./webgl/enums.js";
import s from "./webgl/WGLContainer.js";

var t = /*#__PURE__*/function (_s) {
  _inherits(t, _s);

  var _super = _createSuper(t);

  function t() {
    _classCallCheck(this, t);

    return _super.apply(this, arguments);
  }

  _createClass(t, [{
    key: "requiresDedicatedFBO",
    get: function get() {
      return this.children.some(function (e) {
        return "additive" === e.blendFunction;
      });
    }
  }, {
    key: "prepareRenderPasses",
    value: function prepareRenderPasses(s) {
      var _this = this;

      var _t = s.registerRenderPass({
        name: "bitmap",
        brushes: [e.bitmap],
        target: function target() {
          return _this.children;
        },
        drawPhase: r.MAP
      });

      return [].concat(_toConsumableArray(_get(_getPrototypeOf(t.prototype), "prepareRenderPasses", this).call(this, s)), [_t]);
    }
  }]);

  return t;
}(s);

export { t as BitmapContainer };